import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export type AuditOperation = "Created" | "Updated" | "Deleted";

export interface AuditLog {
  id: number;
  entityName: string;
  entityId: number;
  operation: AuditOperation | string;
  description: string;
  changes: string | null;
  userId: string | null;
  userName: string | null;
  timestamp: string;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

export function getAuditLogs(take?: number | null): Promise<AuditLog[]> {
  const query = take !== null && take !== undefined ? `?take=${take}` : "";
  return request<AuditLog[]>(`/api/auditlogs${query}`);
}
